import { c as _c } from "react/compiler-runtime";
import type * as React from 'react';
import { Alert as ShadcnAlert, AlertDescription as ShadcnAlertDescription, AlertTitle as ShadcnAlertTitle } from '@/components/ui/alert';
import { cn } from '@/lib/ui/utils';

// Morfi semantic tokens (replace stock's text-sm + rounded-lg).
const ALERT_MORFI_TOKENS = 'rounded-overlay text-body' as const;
const ALERT_MORFI_TYPOGRAPHY = 'text-body' as const;
type AlertProps = React.ComponentProps<typeof ShadcnAlert>;
type AlertTitleProps = React.ComponentProps<typeof ShadcnAlertTitle>;
type AlertDescriptionProps = React.ComponentProps<typeof ShadcnAlertDescription>;
export function Alert(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn(ALERT_MORFI_TOKENS, className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <ShadcnAlert className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export function AlertTitle(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <ShadcnAlertTitle {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export function AlertDescription(t0) {
  const $ = _c(8);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  let t1;
  if ($[3] !== className) {
    t1 = cn(ALERT_MORFI_TYPOGRAPHY, className);
    $[3] = className;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== props || $[6] !== t1) {
    t2 = <ShadcnAlertDescription className={t1} {...props} />;
    $[5] = props;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}